import React, { useCallback, useEffect, useState } from "react";
import styles from "./Customers.module.css";
import Footer from "../../components/ui/Footer";
import Navbar from "../../components/ui/Navbar";
import DistributorTable from "../../components/table/DistributorTable";
import successImage from "../../assets/grunge-green-success-word-with-star-icon-rubber-vector-33034681-removebg-preview 1.png";
import Menu from "../../components/ui/Menu";
import DistributorApi from "../../utils/api/DistributorApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { userDataActions } from "../../store/redux-store/Index";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../../components/list/Pagination";
import useDebouncedValue from "../../hooks/useDebouncedValue";

const PIN_PLATFORMS = ["CEI", "NICON", "IEI", "AG", "AGP"];

function DistributorCustomers(props) {
  const [addCustomerModalOpen, setaddCustomerModalOpen] = useState(false);
  const [customerAdded, setCustomerAdded] = useState(false);
  const [fundAgentModal, setFundAgentModal] = useState(false);
  const [sendExpiryModal, setSendExpiryModal] = useState(false);
  const [sendExpiryModalData, setSendExpiryModalData] = useState(null);
  const [allCustomers, setAllCustomers] = useState(null);
  const [fixedAgentId, setFixedAgentId] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const debouncedSearch = useDebouncedValue(searchInput);
  const [pageNumber, setPageNumber] = useState(1);
  const [fundAgentDataModal, setFundAgentDataModal] = useState(false);
  const [fixedAgentData, setFixedAgentData] = useState(null);
  const [input, setInput] = useState({
    password: "",
    phoneNumber: "",
    amountToFund: "",
    email: "",
    name: "",
    businessName: "",
  });

  // const [customerStatus, setCustomerStatus] = useState({
  //   active: 0,
  //   dueSoon: 0,
  //   expired: 0,
  // });

  const [isLoading, setIsLoading] = useState(false);

  const token = useSelector((state) => state.userData.loginData.token);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInput({ ...input, [name]: value });
  };

  const fundAgent = async () => {
    try {
      setIsLoading(true);
      const fundAgent = await DistributorApi.fundAgent({
        fixedagent_id: fixedAgentId,
        amount: input.amountToFund,
        token,
      });
      setFundAgentModal(false);
      setInput({
        amountToFund: "",
      });
      fetchAllAgents();
      toast.success("Agent Funded Successfully", {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        style: {
          backgroundColor: "#FFFFFF",
          color: "#000000",
        },
      });
      setIsLoading(false);
      return fundAgent;
    } catch (err) {
      setIsLoading(false);
      if (err?.response?.data?.message === "Unauthenticated") {
        dispatch(userDataActions.logout());
        window.location.reload();
      }
      toast.error(err?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        style: {
          backgroundColor: "#FFFFFF",
          color: "#000000",
        },
      });
    }
  };

  const fetchAllAgents = useCallback(async () => {
    try {
      const response = await DistributorApi.getAllAgents({
        token,
        page: pageNumber,
        search: debouncedSearch.trim(),
      });
      setAllCustomers(response.data.data);
      // response?.data?.data?.data?.forEach((customer, index) => {
      //   checkCustomerStatus(customer?.expiry_date);
      // });
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      console.error("Failed to fetch customers", error);
    }
  }, [token, pageNumber, debouncedSearch]);

  useEffect(() => {
    fetchAllAgents();
  }, [fetchAllAgents]);

  const customers = allCustomers?.data || [];

  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
    setPageNumber(1);
  };

  const dispatch = useDispatch();

  const addCustomerHandler = async () => {
    try {
      setIsLoading(true);
      const addNewUser = await DistributorApi.addNewAgent({
        phone_no: input.phoneNumber,
        email: input.email,
        fullname: input.name,
        password: input.password,
        business_name: input.businessName,
        token,
      });
      setCustomerAdded(true);
      setInput({
        phone_no: "",
        email: "",
        fullname: "",
        password: "",
        business_name: "",
      });
      fetchAllAgents();
      setIsLoading(false);
      return addNewUser;
    } catch (err) {
      setIsLoading(false);
      if (err?.response?.data?.message === "Unauthenticated") {
        dispatch(userDataActions.logout());
        window.location.reload();
      }
      toast.error(err?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        style: {
          backgroundColor: "#FFFFFF",
          color: "#000000",
        },
      });
    }
  };

  // const checkCustomerStatus = (date) => {
  //   const currentDate = new Date();
  //   const dueDate = new Date(date);

  //   if (dueDate < currentDate) {
  //     setCustomerStatus((prevStatus) => ({
  //       ...prevStatus,
  //       expired: prevStatus.expired + 1,
  //     }));
  //   } else if (dueDate > currentDate) {
  //     setCustomerStatus((prevStatus) => ({
  //       ...prevStatus,
  //       active: prevStatus.active + 1,
  //     }));
  //   } else if (dueDate - currentDate <= 30 * 24 * 60 * 60 * 1000) {
  //     setCustomerStatus((prevStatus) => ({
  //       ...prevStatus,
  //       dueSoon: prevStatus.dueSoon + 1,
  //     }));
  //   }
  // };

  return (
    <div>
      <ToastContainer />
      <div className="menu" onClick={() => props.setShowMenu(false)}>
        {props.showMenu && <Menu setShowMenu={props.setShowMenu} />}
      </div>
      {sendExpiryModal && (
        <div
          className={styles.modal_overlay}
          onClick={() => setaddCustomerModalOpen(false)}
        >
          <div
            className={styles.modal_card}
            onClick={(e) => e.stopPropagation()}
          >
            <h1 className={styles.modal_title}>Add Customer</h1>
            {!customerAdded ? (
              <div>
                <p>
                  Dear {sendExpiryModalData?.fullname}, the papers of your{" "}
                  {sendExpiryModalData?.year} {sendExpiryModalData?.make}{" "}
                  {sendExpiryModalData?.model} with plate number
                  {sendExpiryModalData?.plate_no} expire on the following dates:
                </p>
                <ul>
                  <li>Insurance: insExpiry</li>
                  <li>Vehicle License: vlExpiry</li>
                  <li>Road Tax: rwExpiry</li>
                  <li>POC: pocExpiry</li>
                </ul>
                <p>Please reply to renew and avoid fines.</p>
                <input
                  className={styles.modal_input}
                  type="text"
                  placeholder="Phone Number"
                  defaultValue={sendExpiryModalData?.phone_no?.replace(
                    /(\d{7})/,
                    "*******"
                  )}
                />
                <button
                  className={styles.modal_button}
                  onClick={() => {
                    const phoneNo = sendExpiryModalData?.phone_no;
                    if (phoneNo) {
                      const message = `Dear ${sendExpiryModalData?.fullname}, the papers of your ${sendExpiryModalData?.year} ${sendExpiryModalData?.make} ${sendExpiryModalData?.model} with plate number ${sendExpiryModalData?.plate_no} expire on the following dates: Insurance: ${sendExpiryModalData?.insExpiry}, Vehicle License: ${sendExpiryModalData?.vlExpiry}, Road Tax: ${sendExpiryModalData?.rwExpiry}, POC: ${sendExpiryModalData?.pocExpiry}. Please reply to renew and avoid fines.`;
                      const url = `https://api.whatsapp.com/send?phone=${phoneNo}&text=${encodeURIComponent(
                        message
                      )}`;
                      window.open(url, "_blank");
                    }
                    setSendExpiryModal(false);
                  }}
                >
                  Send whatsapp
                </button>
                <p
                  style={{
                    textDecoration: "underline",
                  }}
                >
                  SMS
                </p>
              </div>
            ) : (
              <div>
                <img
                  src={successImage}
                  alt="success"
                  style={{
                    width: "130px",
                    height: "134px",
                    gap: "0px",
                    opacity: "0px",
                  }}
                />
                <button
                  className={styles.modal_button}
                  onClick={() => setSendExpiryModal(false)}
                >
                  Send whatsapp
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {fundAgentDataModal && (
        <div
          className={styles.modal_overlay}
          onClick={() => setFundAgentDataModal(false)}
        >
          <div
            className={styles.modal_card}
            onClick={(e) => e.stopPropagation()}
          >
            <h1 className={styles.modal_title}>{fixedAgentData?.fullname}</h1>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                width: "90%",
                padding: "20px",
                backgroundColor: "#FFFFFF",
                borderRadius: "10px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid #ccc",
                  paddingBottom: "10px",
                }}
              >
                <h2
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#333",
                  }}
                >
                  Available Pins
                </h2>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  width: "100%",
                  alignItems: "flex-start",
                }}
              >
                {PIN_PLATFORMS.map((platform) => (
                  <div
                    key={platform}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexDirection: "row",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "#666",
                        alignSelf: "flex-start",
                      }}
                    >
                      {platform}:
                    </p>
                    <p
                      style={{
                        fontSize: "16px",
                        fontWeight: "500",
                        color: "#666",
                      }}
                    >
                      {fixedAgentData?.grouped_pins?.[platform]?.length || 0}
                    </p>
                  </div>
                ))}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid #ccc",
                  paddingBottom: "10px",
                }}
              >
                <h2
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#333",
                  }}
                >
                  Number of Orders
                </h2>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <p
                  style={{
                    fontSize: "24px",
                    fontWeight: "700",
                    color: "#333",
                  }}
                >
                  {fixedAgentData?.sales?.length}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {fundAgentModal && (
        <div
          className={styles.modal_overlay}
          onClick={() => setFundAgentModal(false)}
        >
          <div
            className={styles.modal_card}
            onClick={(e) => e.stopPropagation()}
          >
            <h1 className={styles.modal_title}>Fund Agent</h1>
            <div>
              <input
                className={styles.modal_input}
                type="num"
                name="amountToFund"
                onChange={handleInputChange}
                value={input.amountToFund}
                placeholder="Amount To Fund"
              />

              <button
                disabled={isLoading}
                style={{
                  cursor: isLoading ? "not-allowed" : "default",
                  opacity: isLoading ? 0.5 : 1,
                }}
                className={styles.modal_button}
                onClick={fundAgent}
              >
                {isLoading ? `Loading...` : `Add`}
              </button>
            </div>
          </div>
        </div>
      )}

      {addCustomerModalOpen && (
        <div
          className={styles.modal_overlay}
          onClick={() => setaddCustomerModalOpen(false)}
        >
          <div
            className={styles.modal_card}
            onClick={(e) => e.stopPropagation()}
          >
            <h1 className={styles.modal_title}>Add Fixed Agent</h1>
            {!customerAdded ? (
              <div>
                {/* <p className={styles.modal_description}>
                  Dear Customer, the papers of your
                </p> */}
                <input
                  className={styles.modal_input}
                  type="text"
                  name="name"
                  onChange={handleInputChange}
                  value={input.name}
                  placeholder="Fullname"
                />
                <input
                  className={styles.modal_input}
                  type="email"
                  name="email"
                  onChange={handleInputChange}
                  value={input.email}
                  placeholder="Email"
                />

                <input
                  className={styles.modal_input}
                  type="num"
                  name="phoneNumber"
                  onChange={handleInputChange}
                  value={input.phoneNumber}
                  placeholder="Phone Number"
                />

                <input
                  className={styles.modal_input}
                  type="text"
                  name="businessName"
                  onChange={handleInputChange}
                  value={input.businessName}
                  placeholder="Business Name"
                />

                <input
                  className={styles.modal_input}
                  type="text"
                  name="password"
                  onChange={handleInputChange}
                  value={input.password}
                  placeholder="Password"
                />
                <button
                  disabled={isLoading}
                  style={{
                    cursor: isLoading ? "not-allowed" : "default",
                    opacity: isLoading ? 0.5 : 1,
                  }}
                  className={styles.modal_button}
                  onClick={addCustomerHandler}
                >
                  {isLoading ? `Loading...` : `Add`}
                </button>
              </div>
            ) : (
              <div>
                <img
                  src={successImage}
                  alt="success"
                  style={{
                    width: "130px",
                    height: "134px",
                    gap: "0px",
                    opacity: "0px",
                  }}
                />
                <button
                  className={styles.modal_button}
                  onClick={() => {
                    setCustomerAdded(false);
                    setaddCustomerModalOpen(false);
                  }}
                >
                  Send whatsapp
                </button>
                <p
                  style={{
                    textDecoration: "underline",
                  }}
                >
                  SMS
                </p>
              </div>
            )}
          </div>
        </div>
      )}
      <Navbar title="Customers" setShowMenu={props.setShowMenu} />
      <div className={styles.body}>
        {/* <div className={styles.body_header}>
          <div className={styles.customer_stat}>
            <h1>Zero Balance</h1>
            <h1>{customerStatus?.expired}</h1>
          </div>
          <div className={styles.customer_stat}>
            <h1>Low Balance</h1>
            <h1>{customerStatus?.dueSoon}</h1>
          </div>
          <div className={styles.customer_stat}>
            <h1>Good Balance</h1>
            <h1>{customerStatus?.active}</h1>
          </div>
        </div> */}

        <div className={styles.filter_wrapper}>
          <input
            type="text"
            value={searchInput}
            onChange={handleSearchChange}
            placeholder="Search"
            className={styles.filter_input}
          />
          <input
            type="date"
            placeholder="Search transactions"
            className={styles.filter_input}
          />
          <button
            className={styles.export_button}
            onClick={() => setaddCustomerModalOpen(true)}
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.0026 2.33594V11.6693M2.33594 7.0026H11.6693"
                stroke="white"
                stroke-width="4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>

        <DistributorTable
          setSendExpiryModal={setSendExpiryModal}
          tableData={customers}
          setSendExpiryModalData={setSendExpiryModalData}
          table_type="customers"
          setFundAgentModal={setFundAgentModal}
          setFixedAgentId={setFixedAgentId}
          setFundAgentDataModal={setFundAgentDataModal}
          setFixedAgentData={setFixedAgentData}
        />
        <Pagination
          pagination={{
            page: allCustomers?.current_page || pageNumber,
            lastPage: allCustomers?.last_page || 1,
            total: allCustomers?.total || 0,
            hasNextPage: pageNumber < (allCustomers?.last_page || 1),
            hasPreviousPage: pageNumber > 1,
          }}
          onPageChange={setPageNumber}
        />
      </div>
      <Footer />
    </div>
  );
}

export default DistributorCustomers;
